var render = function (_h,_vm) {var _c=_vm._c;return _c('div',[_c('p',{staticClass:"text-3xl font-bold text-serenity-primary"},[_vm._v(_vm._s(_vm.props.description || '-'))]),_c('p',{staticClass:"text-secondary text-xs"},[_vm._v(_vm._s(_vm.props.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }